(() => {
  const initialize = (root) => {
    if (root.dataset.photosReady) return;
    root.dataset.photosReady = 'true';
    const grid = root.querySelector('[data-photo-grid]');
    const cards = Array.from(root.querySelectorAll('[data-photo-card]'));
    const productMode = root.dataset.photoMode === 'product';
    const compact = window.matchMedia('(max-width: 900px)');
    const arrange = () => {
      const count = Math.min(cards.length, compact.matches ? 2 : 4);
      const columns = Array.from({ length: count }, () => {
        const column = document.createElement('div');
        column.className = 'ipcp__column';
        return column;
      });
      const heights = Array(count).fill(0);
      cards.forEach((card) => {
        const preferred = compact.matches || productMode ? -1 : Number(card.dataset.photoColumn);
        const index = Number.isInteger(preferred) && preferred >= 0 && preferred < count
          ? preferred
          : heights.indexOf(Math.min(...heights));
        columns[index].append(card);
        heights[index] += Number(card.dataset.photoRatio) + 0.5;
      });
      grid.replaceChildren(...columns);
      grid.dataset.arranged = 'true';
    };
    arrange();
    compact.addEventListener('change', arrange);

    const dialog = root.querySelector('[data-photo-dialog]');
    if (typeof dialog.showModal !== 'function') return;
    const enlarged = dialog.querySelector('[data-photo-enlarged]');
    const close = dialog.querySelector('[data-photo-close]');
    let opener;
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-photo-open]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const card = link.closest('[data-photo-card]');
      const photo = link.querySelector('img');
      const videoSrc = card.dataset.videoSrc;
      const video = dialog.querySelector('[data-photo-video]');
      if (videoSrc) {
        enlarged.hidden = true;
        video.hidden = false;
        video.poster = photo.currentSrc || photo.src;
        if (video.getAttribute('src') !== videoSrc) video.src = videoSrc;
      } else {
        video.hidden = true;
        video.pause();
        enlarged.hidden = false;
        enlarged.src = photo.currentSrc || photo.src;
        enlarged.alt = photo.alt;
        enlarged.width = photo.width;
        enlarged.height = photo.height;
      }
      const title = dialog.querySelector('[data-dialog-title]');
      title.textContent = videoSrc ? title.dataset.videoTitle : title.dataset.photoTitle;
      dialog.querySelector('[data-dialog-tags]').replaceChildren(...Array.from(card.querySelectorAll('.ipcp__tag'), (tag) => tag.cloneNode(true)));
      const quote = dialog.querySelector('[data-dialog-quote]');
      const full = card.querySelector('[data-quote-full]');
      quote.hidden = !full;
      quote.textContent = full ? full.textContent : '';
      dialog.querySelector('[data-dialog-sponsor]').hidden = !card.hasAttribute('data-ambassador');
      const date = card.querySelector('time');
      const when = dialog.querySelector('[data-dialog-when]');
      const dialogDate = dialog.querySelector('[data-dialog-date]');
      when.hidden = !date;
      dialogDate.textContent = date ? date.textContent : '';
      dialogDate.dateTime = date ? date.dateTime : '';
      dialog.querySelector('[data-dialog-source]').href = card.querySelector('[data-photo-source]').href;
      const photoLink = dialog.querySelector('[data-dialog-photo]');
      photoLink.href = link.href;
      photoLink.hidden = Boolean(videoSrc);
      opener = link;
      dialog.showModal();
      event.preventDefault();
      if (videoSrc) { video.play().catch(() => {}); video.focus(); } else { close.focus(); }
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const video = dialog.querySelector('[data-photo-video]');
      video.pause();
      opener?.focus({ preventScroll: true });
    });
  };
  const scan = (scope) => scope.querySelectorAll('[data-customer-photos]').forEach(initialize);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
